import apiFetch from '../apiFetch'

export default function (campaignId, comment, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/campaign/${campaignId}/Reject`, method: 'PUT', body: comment, token: token, lastAccessDate })
}
